import { createAction } from 'redux-actions';
import { getLinkedStatements } from 'api/statement-api';

export const setLinkedStatementsLoading = createAction(
  'SET_LINKED_STATEMENTS_LOADING',
);
export const setLinkedStatementsLoaded = createAction(
  'SET_LINKED_STATEMENTS_LOADED',
);
export const setLinkedStatementsError = createAction(
  'SET_LINKED_STATEMENTS_ERROR',
);

export const removeLinkedStatementOnUnlink = createAction(
  'REMOVE_LINKED_STATEMENT_ON_UNLINK',
);

export const updateLinkedStmtListStatus = createAction(
  'UPDATE_LINKED_STMT_LIST_STATUS',
);
export const clearLinkedStatements = createAction('CLEAR_LINKED_STATEMENTS');

export const getLinkedStatementsAction =
  (projectId, statementId, revisionId, withoutLoading = false) =>
  async (dispatch) => {
    try {
      if (!withoutLoading) {
        dispatch(setLinkedStatementsLoading());
      }
      const response = await getLinkedStatements({
        projectId,
        statementId,
        revisionId,
      });
      dispatch(setLinkedStatementsLoaded(response));
    } catch (e) {
      dispatch(setLinkedStatementsError(e));
    }
  };
